// Footer.tsx

import { Link } from "react-router-dom";

const Footer = () => {
  return (
    // 가로 크기 100% 가운데 정렬
    <footer className="footer font-[Pretendard]">
      <div className="company-info  bg-[#E9E9E9] max-w-[716px] flex flex-col items-center justify-center m-auto py-2">
        <div className="flex gap-2 text-sm text-gray-500 mb-2">
          <Link target="_blank" to="/terms/pay/use" className="underline">
            이용약관
          </Link>
          <Link target="_blank" to="/terms/pay/privacy" className="underline">
            개인정보처리방침
          </Link>
        </div>
        <p className="company-name">이규호사주TV</p>
        <p className="company-details">
          대표: 이규호 | 사업자등록번호: 677-04-02000
        </p>
        <p className="company-address">
          주소: 경기도 광명시 서부샛길 778, 1103호(철산동, 오피스텔)
        </p>
        {/* 유선 전화 번호 */}
        <p className="company-contact">유선 전화: 010-7610-1330</p>
        {/* 이메일 */}
        <p className="company-contact">이메일: s295@naver.com</p>
        <p className="copyright">이규호사주TV @ 2025 All Rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
